module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "search-wrapper all"
  }, [_vm._t("select"), _vm._v(" "), (_vm.Pic.show) ? _c('ts-tag', {
    attrs: {
      "shape": "square",
      "type": "transparent",
      "closable": ""
    },
    on: {
      "close": _vm.handleDelPic
    }
  }, [_c('div', {
    staticClass: "search-mask"
  }, [_c('img', {
    attrs: {
      "src": _vm.Pic.url,
      "width": "20",
      "height": "20"
    }
  }), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        _vm.handleSearchFromEdit(_vm.Pic.url)
      }
    }
  }, [_c('i', {
    staticClass: "icon-bianji"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.showTab) ? _c('p', {
    staticClass: "search-tab"
  }, _vm._l((_vm.options), function(item) {
    return _c('span', {
      class: {
        'selected': item.isSelected
      },
      on: {
        "click": function($event) {
          _vm.tabSwitch(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Search.val),
      expression: "Search.val"
    }],
    staticClass: "search-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.inputPlaceHolder,
      "disabled": _vm.search.handleStatus
    },
    domProps: {
      "value": (_vm.Search.val)
    },
    on: {
      "focus": _vm.handleDelPic,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleSearchText($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Search.val = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.search.handleStatus) ? _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.Pic.isUploaded),
      expression: "!Pic.isUploaded"
    }],
    staticClass: "icon-sousuo search-upload--icon",
    on: {
      "click": _vm.handleSearchText
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Pic.isUploaded),
      expression: "Pic.isUploaded"
    }],
    staticClass: "search-close",
    on: {
      "click": function($event) {
        _vm.Pic.isUploaded = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('ts-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.Pic.isUploaded),
      expression: "!Pic.isUploaded"
    }],
    staticClass: "search-button",
    attrs: {
      "type": "primary",
      "disabled": _vm.search.handleStatus
    },
    on: {
      "click": _vm.handleUpload
    }
  }, [_c('i', {
    staticClass: "icon-xiangji"
  }), _vm._v("传图搜花\r\n    ")])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Pic.isUploaded),
      expression: "Pic.isUploaded"
    }],
    staticClass: "search-editPic onepx"
  }, [_c('p', {
    staticClass: "search-editPic-title"
  }, [_c('span', [_vm._v("搜索历史")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('a', {
    staticClass: "search-editPic-upload--button",
    on: {
      "click": _vm.handleUpload
    }
  }, [_c('i', {
    staticClass: "icon-shangchuan"
  }), _vm._v("\r\n          本地上传\r\n        ")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "input",
    attrs: {
      "type": "file",
      "accept": "image/png,image/jpeg"
    },
    on: {
      "change": _vm.uploadImg
    }
  })]), _vm._v(" "), _c('ts-grid', {
    attrs: {
      "data": _vm.showPics,
      "emptyText": "暂无搜索记录"
    }
  }, _vm._l((_vm.showPics), function(product) {
    return _c('ts-grid-item', {
      key: product,
      staticStyle: {
        "width": "115px"
      },
      on: {
        "click": function($event) {
          _vm.handleChoosePic(product)
        }
      }
    }, [_c('ts-image', {
      attrs: {
        "width": "60",
        "height": "60",
        "canView": false,
        "disabledHover": "",
        "src": product
      }
    })], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "search-editPic-menu"
  }, [_c('ts-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleClearHistory
    }
  }, [_vm._v("清空记录")]), _vm._v(" "), _c('ts-button', {
    attrs: {
      "type": "cancel"
    },
    on: {
      "click": function($event) {
        _vm.Pic.isUploaded = !_vm.Pic.isUploaded
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.search.handleStatus && !_vm.Pic.isUploaded),
      expression: "search.handleStatus&&!Pic.isUploaded"
    }],
    staticClass: "search-editPic onepx"
  }, [_c('ts-button', {
    staticClass: "upload-tip--button button",
    attrs: {
      "type": "cancel",
      "size": "small"
    },
    on: {
      "click": _vm.handleCanceSearch
    }
  }, [_vm._v("取消搜索")]), _vm._v(" "), (!_vm.overtime.status) ? _c('p', {
    staticClass: "upload-tip"
  }, [_vm._v(" 正在处理中，请稍候...")]) : _vm._e(), _vm._v(" "), (!_vm.overtime.status) ? _c('ts-progress', {
    attrs: {
      "percentage": _vm.search.progress
    }
  }) : _vm._e(), _vm._v(" "), (_vm.overtime.status) ? _c('p', {
    staticClass: "upload-tip"
  }, [_vm._v("请重新上传图片再次搜索")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.overtime.status),
      expression: "overtime.status"
    }],
    staticClass: "search-editPic onepx"
  }, [_c('p', {
    staticClass: "upload-tip"
  }, [_vm._v("非常抱歉，未能找到结果，请稍后再试")])]), _vm._v(" "), _c('cropper-dialog', {
    attrs: {
      "dialog": _vm.Cropper,
      "imageUrl": _vm.Pic.url
    },
    on: {
      "check": _vm.handleLookProduct,
      "change": _vm.handleGetResult
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-909c3e50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/search.vue
// module id = 849
// module chunks = 39